import { boolean, type InferType, object, tuple, ValidationError } from 'yup';

const SCHEMA = tuple([
  object({
    isCartEmpty: boolean().required().isFalse('error.cart_empty'),
    isProcessEmpty: boolean().required().isTrue('error.syncing'),
  }),
  object({
    isUserReady: boolean().required().isTrue('error.user_invalid'),
  }),
  object({
    isDeliveryReady: boolean().required().isTrue('error.delivery_invalid'),
  }),
  object({
    isPaymentExists: boolean().required().isTrue('error.payment_missing'),
  }),
  object({
    isPaymentReady: boolean().required().isTrue('error.payment_invalid'),
  }),
  object({
    isReady: boolean().required().isTrue('error.order_incomplete'),
  }),
]);

export enum OrderValidationStatusEnum {
  success = 'success',
  failed = 'failed',
  processed = 'processed',
}

export default () => {
  const orderStore = useOrderStore();

  return computed<
    | {
        status: OrderValidationStatusEnum;
        message?: never;
      }
    | {
        status: OrderValidationStatusEnum.failed;
        message: I18nLocale;
      }
  >(() => {
    if (!orderStore.initialized)
      return { status: OrderValidationStatusEnum.processed };

    try {
      SCHEMA.validateSync(<InferType<typeof SCHEMA>>[
        {
          isCartEmpty: !orderStore.cartData.length,
          isProcessEmpty: !orderStore.blockKeys.length,
        },
        { isUserReady: orderStore.isUserReady },
        { isDeliveryReady: orderStore.delivery.isReady },
        {
          isPaymentExists: orderStore.payment.variants.some(
            (el) => orderStore.payment.current?.type === el.type,
          ),
        },
        { isPaymentReady: orderStore.payment.isReady },
        { isReady: orderStore.isReady },
      ]);

      return { status: OrderValidationStatusEnum.success };
    } catch (error) {
      return {
        status: OrderValidationStatusEnum.failed,
        message: (<ValidationError>error).errors[0],
      };
    }
  });
};
